const theme = {
  colors: {
    primary: '#1A365D',
    primaryLight: '#2A4A7F',
    primaryDark: '#0F2440',
    accent: '#319795',
    accentLight: '#4FD1C5',
    success: '#38A169',
    warning: '#D69E2E',
    danger: '#E53E3E',
    text: '#1A202C',
    textLight: '#718096',
    textMuted: '#A0AEC0',
    bg: '#FFFFFF',
    bgAlt: '#F7FAFC',
    bgCard: '#FFFFFF',
    border: '#E2E8F0',
    borderLight: '#EDF2F7',
  },
  fonts: {
    body: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif",
    mono: "'SF Mono', 'Fira Code', monospace",
  },
  radius: '8px',
  radiusSm: '4px',
  shadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.06)',
  shadowMd: '0 4px 6px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.06)',
};

export default theme;
